import { dollarsToCents } from '../misc';

export default function processReceiptItem(
  rawItem: RawReceiptItem,
): ReceiptItem {
  return {
    id: rawItem.PLUCode,
    price: dollarsToCents(rawItem.Price),
    quantity: rawItem.Qty,
    ingredients: flattenItems(rawItem.Ingredients).map(processReceiptItem),
    name: rawItem.Item,
    choicesets: flattenChoiceSet(rawItem.ChoiceSets).map(processReceiptItem),
    points: rawItem.Points,
  };
}

function flattenItems(ingredients: RawReceiptItem[] = []): RawReceiptItem[] {
  const flattenedIngredients: RawReceiptItem[] = [];

  ingredients.forEach(ingredient => {
    const withoutNested = { ...ingredient, Ingredients: [] };

    flattenedIngredients.push(withoutNested);

    ingredient.Ingredients.forEach(nestedIngredient => {
      flattenedIngredients.push(nestedIngredient);
    });
  });

  return flattenedIngredients;
}

function flattenChoiceSet(choicesets: RawReceiptItem[] = []): RawReceiptItem[] {
  const flattenedIngredients: RawReceiptItem[] = [];

  const allChoices = Object.values(choicesets).flat();

  allChoices.forEach(choiceset => {
    const withoutNested = { ...choiceset, ChoiceSets: [] };

    flattenedIngredients.push(withoutNested);

    // Flatten the nested choice sets
    const nestedChoices = Object.values(choiceset.ChoiceSets).flat();

    nestedChoices.forEach(choiceset => {
      flattenedIngredients.push(choiceset);
    });
  });

  return flattenedIngredients;
}
